import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import Logo from "@/components/Logo";

export default function AuthCallback() {
  const { completeGoogle } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const qs = new URLSearchParams(location.search);
    const inviteCode = qs.get("invite") || "";
    const accountType = qs.get("type") === "manager" ? "manager" : "employee";
    const acceptedTerms = new URLSearchParams(location.search).get("terms") === "1";
    completeGoogle(sessionId, inviteCode, acceptedTerms, accountType)
      .then((u) => { toast.success(`Welcome, ${u.name}`); nav("/app/chat", { replace: true }); })
      .catch((e) => { toast.error(e?.response?.data?.detail || "Google sign-in failed"); nav("/login", { replace: true }); });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="auth-callback" className="min-h-screen bg-[#F5F9FE] flex flex-col items-center justify-center gap-3 text-slate-600">
      <Logo size={48} />
      <div className="text-sm">Signing you in with Google…</div>
    </div>
  );
}
